export const enviroment = {
  name: 'production',
  production: true,
  api: 'https://654542c15a0b4b04436de1c8.mockapi.io/api/v1/',
  url: ' https://thtpoyv2l9.execute-api.us-west-2.amazonaws.com/',
  url_cdn: 'https://d222mlsqvt1uax.cloudfront.net/',
  archivo_contrato_colectivo: 'https://d222mlsqvt1uax.cloudfront.net/documentos/Contrato_Colectivo_Copec.pdf',
  archivo_brochure_beneficios: 'https://d222mlsqvt1uax.cloudfront.net/documentos/BENEFICIOS-2026.pdf',
  template_reconocimiento_deuda: 'https://d222mlsqvt1uax.cloudfront.net/documentos/template_reconocimiento_de_deuda.pdf',
  template_reconocimiento_deuda_compania: 'https://d222mlsqvt1uax.cloudfront.net/documentos/RECONOCIMIENTO_CLP.pdf',
  template_reconocimiento_deuda_bienestar: 'https://d222mlsqvt1uax.cloudfront.net/documentos/RECONOCIMIENTO_CLP.pdf',
  template_reconocimiento_deuda_viajes: 'https://d222mlsqvt1uax.cloudfront.net/documentos/RECONOCIMIENTO_CLP.pdf',
  template_reconocimiento_deuda_libre_disposicion: 'https://d222mlsqvt1uax.cloudfront.net/documentos/RECONOCIMIENTO_CLP.pdf',
  template_reconocimiento_deuda_compra_vivienda: 'https://d222mlsqvt1uax.cloudfront.net/documentos/RECONOCIMIENTO_UF.pdf',
  template_reconocimiento_deuda_reparacion_vivienda: 'https://d222mlsqvt1uax.cloudfront.net/documentos/RECONOCIMIENTO_UF.pdf',
  formato_carga_participantes: 'https://d222mlsqvt1uax.cloudfront.net/documentos/Formato_Carga_de_Participantes.xlsx',
  template_reconocimiento_deuda_credito_medico:'https://d39wx839mc90rh.cloudfront.net/documentos/PRESTAMO_RECONOCIMIENTO_DEUDA_TR.pdf',

  // Caja navidad
  detalle_caja_2026: 'https://d222mlsqvt1uax.cloudfront.net/documentos/Detalle_cajas_2026.pdf',

  fusionAuthConfig: {
    timeoutFactor: 0.9,
    client_id: '63af1f8f-c2a7-482a-a053-c6a072127974',
    issuer: 'https://copec-sa.fusionauth.io',
  },
};
